// Generated by purs version 0.15.14
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var TakeFromPrepareResult = /* #__PURE__ */ (function () {
    function TakeFromPrepareResult() {

    };
    TakeFromPrepareResult.value = new TakeFromPrepareResult();
    return TakeFromPrepareResult;
})();
var Value = /* #__PURE__ */ (function () {
    function Value(value0) {
        this.value0 = value0;
    };
    Value.create = function (value0) {
        return new Value(value0);
    };
    return Value;
})();
var decodeJsonConfigSource = function (dictDecodeJson) {
    var decodeJson = Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonMaybe(dictDecodeJson));
    return {
        decodeJson: function (json) {
            var mb = decodeJson(json);
            var convert = function (v) {
                if (v instanceof Data_Maybe.Nothing) {
                    return TakeFromPrepareResult.value;
                };
                if (v instanceof Data_Maybe.Just) {
                    return new Value(v.value0);
                };
                throw new Error("Failed pattern match at Fusion.Types (line 82, column 17 - line 84, column 26): " + [ v.constructor.name ]);
            };
            return map(convert)(mb);
        }
    };
};
export {
    TakeFromPrepareResult,
    Value,
    decodeJsonConfigSource
};
